<template>
  <div class="surface-0 landingLayout" :style="backgroundImageStyle">
    <div class="mobile-background">
      <div class="flex align-items-center justify-content-center min-h-screen">
        <div class="flex flex-column align-items-center">
          <img v-if="page && page.featuredImage" :src="resolveImageUrl(page.featuredImage)" alt="Featured Image" class="w-20rem object-cover">
          <h1 class="font-medium p-4">{{ page?.altTitle || page?.title || 'Untitled Page' }}</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  page: Object,
  settings: Object
});

import { useCommonStyles } from '../composables/useCommonStyles.js';
import { useMediaHelpers } from '../composables/useMediaHelpers.js';
const { resolveImageUrl } = useMediaHelpers();
const { backgroundImageStyle } = useCommonStyles(props);
</script>
